export default class CountryVerification {
  static isInCorrectCountry(countryCode) {
    const environment = this.getEnvironment();
    countryCode = countryCode?.toLowerCase() || "";
    return (
      this.isNonProduction(environment) ||
      countryCode === environment ||
      (countryCode === "" && environment == "prod")
    );
  }

  static getEnvironment() {
    const hostname = window.location.hostname.toLowerCase();
    let domainSplit = hostname.split(".");
    const storagePrefix = "augmeditstorageweb";
    let domainStart = domainSplit[0];
    if (domainStart == "preview") domainStart = domainStart[1];
    if (domainStart.startsWith(storagePrefix))
      return domainStart.substring(storagePrefix.length);
    return domainStart === "www" ? "prod" : domainStart;
  }

  static isUsSite() {
    // Make it possible to see the about box before deploying on us site
    const countryCodeOnUrl = new URL(location.href).searchParams.get(
      "countryCode"
    );

    return (
      countryCodeOnUrl === "us" || CountryVerification.getEnvironment() === "us"
    );
  }

  static isNonProduction(environment) {
    if (!environment) environment = this.getEnvironment();
    return (
      environment === "lab" ||
      environment === "acc" ||
      environment === "test" ||
      environment === "localhost"
    );
  }

  static getUrlForRegion(countryCode) {
    if (!countryCode) countryCode = "www";
    const domainName = [countryCode.toLowerCase(), "lumi.cloud"]
      .filter(Boolean)
      .join(".");
    return window.location.protocol + "//" + domainName;
  }
}
